// @flow
import React, { useState } from "react";
import styled, { css } from "styled-components";
import Media from "react-media";
import { Redirect } from "react-router-dom";
import Gettext from "../common/Gettext";
import Cup from "../Icons/Tournaments/ColorfulCup";
import Orientation, { isLandscape } from "../common/Orientation";
import { gaReducer } from "../GA";
import withData from "../withData";
import { get } from "../common/fetch";

const SlideTitle = styled.div`
  height: 62px;
  padding-top: 10px;
  font-weight: 500;
  font-size: 52px;
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.sightseeingTitle : "#fff")};

  @media (max-height: 840px) {
    height: 42px;
    padding-top: 0;
    font-size: 32px;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 586px;
  margin: 20px auto;
  margin-top: 50px;
  margin-bottom: 48px;

  @media (max-height: 840px) {
    margin-top: 10px;
    margin-bottom: 18px;
  }
`;

const CenterImage = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 486px;
  height: 331px;
  box-shadow: 0 0 20px ${({ theme }) => theme.sightSeeingImageShadow};
  background-color: ${({ isIntlProject, theme }) =>
  isIntlProject ? theme.indexMajor : "#251f2b"};
`;

const NextButton = styled.div`
  display: inline-block;
  height: 57px;
  min-width: 300px;
  margin-top: 20px;
  padding: 0 20px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  border-radius: 90px;
  border: none;
  line-height: 57px;
  cursor: pointer;
  vertical-align: top;
  text-decoration: none;
  color: ${props => props.theme.sightSeeingStartButtonColor};
  background: ${props => props.theme.sightSeeingStartButtonBg};
`;

const HelpButton = styled(NextButton)`
  display: inline-block;
  margin-right: ${props => (props.theme.direction !== "rtl" ? "20px" : 0)};
  margin-left: ${props => (props.theme.direction !== "rtl" ? 0 : "20px")};
  background: none;
  border: 2px solid
    ${({ isIntlProject, theme }) => (isIntlProject ? theme.themeToggleActive : "#fff")};
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.themeToggleActive : "#fff")};
  text-decoration: none;
  line-height: 55px;
`;

const ButtonsContainer = styled.div`
  direction: ${props => props.theme.direction};
`;

const TextTutor = styled.div`
  margin-bottom: 20px;
  font-size: 18px;
  line-height: 1.2;
  text-align: center;
  cursor: default;
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.sightseeingTitle : "#fff")};
`;

const BigBg = styled.div`
  position: relative;
  z-index: 2;
  width: 29px;
  height: 280px;
  background: ${({ theme }) => theme.sightseeingBigBg};
  box-shadow: 0 0 20px ${({ theme }) => theme.sightSeeingBgShadow};
`;

const SmallBg = styled.div`
  position: relative;
  z-index: 1;
  width: 21px;
  height: 220px;
  background: ${({ theme }) => theme.sightseeingSmallBg};
  box-shadow: 0 0 20px ${({ theme }) => theme.sightSeeingBgShadow};
`;

const Popup = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  overflow: auto;
`;

const Table = styled.div`
  display: table;
  vertical-align: middle;
  width: 100%;
  height: 100%;
`;

const Cell = styled.div`
  display: table-cell;
  vertical-align: middle;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1000px;
  width: 95%;
  height: 792px;
  margin: 0 auto;
  padding: 50px 75px 44px 75px;
  text-align: center;
  border-radius: 20px;
  background: ${props =>
    props.isIntlProject ? props.theme.sightseeingBg : props.theme.sightseeingBg};
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

  @media (max-width: 1000px) {
    max-width: 940px;
    width: 100%;
  }

  @media (max-height: 840px) {
    height: 615px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

const SliderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: ${props => props.theme.main};
  z-index: 9999999;
`;

const SliderView = styled.div`
  width: 100%;
  height: 100%;
`;

const Slide = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  height: 100%;
  overflow: hidden;
  -webkit-text-size-adjust: 100%;

  ${props =>
    props.isLandscape &&
    css`
      flex-direction: row;
    `};
`;

const LastSlideC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  min-height: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: auto;

  ${props =>
    props.isLandscape &&
    css`
      padding-top: 20px;
      padding-bottom: 20px;
    `};
`;

const FirstTitle = styled.div`
  width: 100%;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  padding: 0 20px;
  font-weight: 500;
  font-size: 28px;
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.sightseeingTitle : "#fff")};
  text-align: center;

  @media (min-width: 360px) {
    font-size: 32px;
  }

  ${props =>
    props.last &&
    css`
      font-size: 32px;

      @media (min-width: 600px) {
        font-size: 40px;
      }
    `};
`;

const SubTitle = styled.div`
  text-align: center;
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.sightseeingTitle : "#fff")};

  font-size: 22px;
  padding-top: 15px;
  padding-left: 5px;
  padding-right: 5px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      font-size: 16px;
      padding-top: 0;
      padding-bottom: 15px;
    `};
`;

const FirstText = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 10px auto 20px;
  padding: 0 20px;
  font-size: 20px;
  line-height: 1.2;
  color: ${({ isIntlProject, theme }) => (isIntlProject ? theme.sightseeingTitle : "#fff")};
  text-align: center;

  @media (min-width: 600px) {
    margin-bottom: 40px;
    font-size: 24px;
  }

  ${props =>
    props.isLandscape &&
    css`
      margin-bottom: 30px;
    `};
`;

const Button = styled.div`
  display: block;
  max-width: 297px;
  width: 90%;
  height: 45px;
  margin: 0 auto;
  font-size: 18px;
  text-align: center;
  text-transform: uppercase;
  color: ${props => props.theme.sightSeeingStartButtonColor};
  background: ${props => props.theme.sightSeeingStartButtonBg};
  border: none;
  border-radius: 25px;

  @media (max-width: 600px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "14px"};
  }
`;

const LinkButton = styled(Button)`
  display: block;
  max-width: 297px;
  width: 90%;
  height: 45px;
  margin: 0 auto;
  font-size: 18px;
  text-align: center;
  text-transform: uppercase;
  color: ${props => props.theme.sightSeeingStartButtonColor};
  background: ${props => props.theme.sightSeeingStartButtonBg};
  border: none;
  border-radius: 25px;

  @media (max-width: 600px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "14px"};
  }

  line-height: 45px;
  text-decoration: none;

  ${props =>
    props.help &&
    css`
      margin-bottom: 15px;
      line-height: 43px;
      background: transparent;
      border: 2px solid
        ${({ isIntlProject, theme }) => (isIntlProject ? theme.themeToggleActive : "#fff")};
      color: ${({ isIntlProject, theme }) =>
      isIntlProject ? theme.themeToggleActive : "#fff"};
    `};

  ${props =>
    props.isLandscape &&
    css`
      flex-basis: 50%;
      width: 50%;
      margin-left: 10px;
      margin-right: 10px;
    `};
`;

const Links = styled.div`
  width: 100%;

  ${props =>
    props.isLandscape &&
    css`
      display: flex;
      flex-direction: row;
      max-width: 600px;
      margin: 0 auto;
    `};
`;

const endTour = (serverData, profile, dispatch, redirect, tour) => {
  get(`/tours/stats?action=2&tour=tour${tour.analyticsID}`);
  if (profile != null) {
    try {
      get("/ajax/saveSettings/?name=tourShown&value=1").then(() => {
        get("/api/server-data").then(serverData => {
          dispatch({
            type: "RECEIVE_SERVER_DATA",
            payload: serverData
          });
          redirect();
        });
      });
    } catch (error) {
      console.log("tourShown ajax ", error);
    }
  } else {
    try {
      get("/api/server-data").then(serverData => {
        dispatch({
          type: "RECEIVE_SERVER_DATA",
          payload: serverData
        });
        redirect();
      });
    } catch (error) {
      console.log("tourShown ajax ", error);
    }
  }
};

const LastSlideComponent = props => {
  const [redirecting, redirect] = useState(null);

  if (redirecting != null) {
    return <Redirect push to={redirecting} />;
  }

  return (
    <Media query="(max-width: 959px)">
      {matches =>
        matches ? (
          <Orientation>
            {screen => (
              <SliderContainer ref={props.forwardedRef}>
                <SliderView>
                  <Slide>
                    <LastSlideC isLandscape={isLandscape(screen)}>
                      <FirstTitle
                        last
                        isIntlProject={
                          process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                        }
                      >
                        <Gettext>Congratulations!</Gettext>
                      </FirstTitle>
                      <SubTitle
                        isIntlProject={
                          process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                        }
                        isMobile={matches}
                      >
                        <Gettext>
                          You have made a good choice! Your forecast is correct!
                        </Gettext>
                      </SubTitle>
                      <Cup width={70} />
                      <FirstText
                        isIntlProject={
                          process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                        }
                      >
                        <Gettext>
                          Trading strategies, video tutorials and much more on
                          the pages of our Help Center
                        </Gettext>
                      </FirstText>
                      <Links isLandscape={isLandscape(screen)}>
                        <LinkButton
                          help
                          isLandscape={isLandscape(screen)}
                          onClick={() => {
                            endTour(
                              props.serverData,
                              props.profile,
                              props.dispatch,
                              () => redirect("/helpdesk"),
                              props.tour
                            );
                            gaReducer(`CLICK_HELP_TOUR_${props.tour.analyticsID}`);
                          }}
                          isIntlProject={
                            process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                          }
                        >
                          <Gettext>Go to help center</Gettext>
                        </LinkButton>
                        <LinkButton
                          isLandscape={isLandscape(screen)}
                          onClick={() => {
                            endTour(
                              props.serverData,
                              props.profile,
                              props.dispatch,
                              () => redirect("/trade"),
                              props.tour
                            );
                            gaReducer(`CLICK_TRADE_TOUR_${props.tour.analyticsID}`);
                          }}
                          isIntlProject={
                            process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                          }
                        >
                          <Gettext>Trade now</Gettext>
                        </LinkButton>
                      </Links>
                    </LastSlideC>
                  </Slide>
                </SliderView>
              </SliderContainer>
            )}
          </Orientation>
        ) : (
          <Popup>
            <Table>
              <Cell>
                <Container
                  isIntlProject={process.env.REACT_APP_DEPLOY_TARGET === "irontrade"}
                >
                  <div>
                    <SlideTitle
                      isIntlProject={
                        process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                      }
                    >
                      <Gettext>Congratulations!</Gettext>
                    </SlideTitle>
                    <SubTitle
                      isIntlProject={
                        process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                      }
                      isMobile={matches}
                    >
                      <Gettext>
                        You have made a good choice! Your forecast is correct!
                      </Gettext>
                    </SubTitle>
                    <ImageContainer>
                      <SmallBg />
                      <BigBg />
                      <CenterImage
                        isIntlProject={
                          process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                        }
                      >
                        <Cup width={180} />
                      </CenterImage>
                      <BigBg />
                      <SmallBg />
                    </ImageContainer>
                    <TextTutor
                      isIntlProject={
                        process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                      }
                    >
                      <Gettext>
                        Trading strategies, video tutorials and much more on the
                        pages of our Help Center
                      </Gettext>
                    </TextTutor>
                    <ButtonsContainer>
                      <HelpButton
                        onClick={() => {
                          endTour(
                            props.serverData,
                            props.profile,
                            props.dispatch,
                            () => redirect("/helpdesk"),
                            props.tour
                          );
                          gaReducer(`CLICK_HELP_TOUR_${props.tour.analyticsID}`);
                        }}
                        isIntlProject={
                          process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                        }
                      >
                        <Gettext>Go to help center</Gettext>
                      </HelpButton>
                      <NextButton
                        onClick={() => {
                          endTour(
                            props.serverData,
                            props.profile,
                            props.dispatch,
                            () => redirect("/trade"),
                            props.tour
                          );
                          gaReducer(`CLICK_TRADE_TOUR_${props.tour.analyticsID}`);
                        }}
                      >
                        <Gettext>Get started</Gettext>
                      </NextButton>
                    </ButtonsContainer>
                  </div>
                </Container>
              </Cell>
            </Table>
          </Popup>
        )
      }
    </Media>
  );
};

const LastSlide = React.forwardRef((props, ref) => (
  <LastSlideComponent {...props} forwardedRef={ref} />
));

export default withData(["serverData", "profile"])(LastSlide);



// WEBPACK FOOTER //
// ./src/components/Sightseeing/Outro.js